import checkout from "./form";

const {
  formField: { email, password, repeatPassword, firstname, lastname, role },
} = checkout;

const initialValues = {
  [email.name]: "",
  [password.name]: "",
  [repeatPassword.name]: "",
  [firstname.name]: "",
  [lastname.name]: "",
  [role.name]: "USER",
};

export default initialValues;
